import React, { useState, useEffect, useRef } from 'react';
import { Card, ListGroup, Spinner, Alert } from 'react-bootstrap';
import { announcementService } from '../services/api';
import config from '../config';
import './LatestAnnouncements.css';

const LatestAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const scrollRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // Auto-scroll effect
  useEffect(() => {
    if (!scrollRef.current || loading || announcements.length === 0) return;

    const scrollElement = scrollRef.current;
    let animationId;
    let scrollPosition = 0;
    const speed = 0.5; // pixels per frame

    const scroll = () => {
      if (!isHovered) {
        scrollPosition += speed;
        scrollElement.scrollTop = scrollPosition;

        // Reset to top when reaching the end
        if (scrollPosition >= scrollElement.scrollHeight - scrollElement.clientHeight) {
          scrollPosition = 0;
          scrollElement.scrollTop = 0;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [loading, announcements, isHovered]);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const response = await announcementService.getAnnouncements();
      // Handle both response.data.announcements and response.announcements
      const announcementsList = response.data?.announcements || response.announcements || [];
      setAnnouncements(Array.isArray(announcementsList) ? announcementsList : []);
    } catch (err) {
      console.error('Error fetching announcements:', err);
      setAnnouncements([]); // Set empty array on error
      setError('Failed to load announcements');
    } finally {
      setLoading(false);
    }
  };

  const handleAnnouncementClick = (announcement) => {
    const fileUrl = `${config.UPLOAD_BASE_URL}/${announcement.file_path}`;
    window.open(fileUrl, '_blank');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <Card className="latest-announcements-card">
      <Card.Header className="bg-primary text-white">
        <h5 className="mb-0">Controller of Examinations - Latest Announcements</h5>
      </Card.Header>
      <Card.Body className="p-0">
        <div
          ref={scrollRef}
          className="scroll-area announcement-widget mb-2"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ height: '300px', overflowY: 'auto' }}
        >
          {error && <Alert variant="danger" className="m-3">{error}</Alert>}

          {announcements.length === 0 ? (
            <div className="text-center p-4 text-muted">
              No announcements available
            </div>
          ) : (
            <ListGroup variant="flush">
              {announcements.map((announcement, index) => (
                <ListGroup.Item
                  key={announcement.id}
                  className="announcement-item"
                  onClick={() => handleAnnouncementClick(announcement)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="">{announcement.title}</div>
                      <div className="date">
                        {formatDate(announcement.announcement_date)}
                      </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default LatestAnnouncements;